import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { SftpExplorerTable } from "@/features/admin/components/SftpExplorerTable";
import { sftpBreadcrumbTrail } from "@/features/admin/constants/sftpNav";
import { useSftpExplorer } from "@/features/admin/hooks/useSftpExplorer";
import { useNav } from "@/utils/nav";

function SftpOrganisationsPage() {
    useNav(sftpBreadcrumbTrail("Organisations"));
    const { data, isLoading, isFetching, error, refetch } = useSftpExplorer();

    return (
        <div className="space-y-4 w-full min-w-0">
            <div>
                <h2 className="font-semibold text-lg">Organisations</h2>
                <p className="mt-1 text-muted-foreground text-sm">
                    Each row is an SFTP folder on the renderer. Select an organisation to see its diaries, or expand a
                    row to browse PDF and JSON files on disk.
                </p>
            </div>

            {isLoading ? (
                <div className="flex justify-center py-16 text-muted-foreground">
                    <Loader2 className="mr-2 w-5 h-5 animate-spin" />
                    Loading organisations...
                </div>
            ) : error ? (
                <div className="p-4 border border-rose-200 rounded-lg text-rose-800 text-sm">
                    {error instanceof Error ? error.message : "Failed to load organisations"}
                </div>
            ) : data ? (
                <SftpExplorerTable data={data} isFetching={isFetching} onRefresh={() => void refetch()} />
            ) : null}
        </div>
    );
}

export const Route = createFileRoute("/_app/developer/sftp/organisations")({
    component: SftpOrganisationsPage,
});
